import { ChatSessionsData } from 'core_main/api/sessions/types';
import { getStore } from 'core_main/store';
import { ConversationCallbackResponse } from '../types';

export const createGetConversationCallbackResponse = (
  session: ChatSessionsData,
): ConversationCallbackResponse => {
  const { id: conversationId } = session;
  const { createdAt, preview, lastMessageAt, lockedAt } = session.attributes;
  const useLegacy = getStore().useLegacyConversationPreview;
  const name =
    useLegacy ? undefined : (session.attributes.name ?? undefined);

  return {
    conversationId,
    createdAt,
    preview,
    lastMessageAt,
    ended: !!lockedAt,
    ...(name !== undefined && name !== '' ? { name } : {}),
  };
};
